import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { getSession, postOrPutRequest, validateData } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import FormError from "../../components/FormError";
// import MainSectionLayout from "../../layout/MainSectionLayout";

const InfoOrg3 = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [formulario, setFormulario] = useState({
        names: '',
        lastnames: '',
        // email: '',
        about_us: '',
    });

    const [alert, setAlert] = useState([{
        inputName: "",
        status: false,
        message: ""
    }]);

    const validateDataForm = (e) => {
        e.preventDefault();

        let inputs = Object.entries(formulario).map(([key, value]) => {
            return {
                name: key,
                value: value,
            };
        });

        const datosValidados = validateData(inputs);
        // console.log(datosValidados)
        setAlert(datosValidados);

        let totalValidaciones = datosValidados.filter((input) => input.status !== false).map(() => {
            return false
        });

        if (totalValidaciones.length < 1) {
            // Swal.fire({
            // 	title: 'cargando...',
            // 	text: 'Por favor espere',
            // 	allowOutsideClick: false,
            // 	didOpen: () => {
            // 		Swal.showLoading();
            // 	}
            // });
            // sendData();
        }
    }

    const hanldeChange = (e) => {
        let newForm = { ...formulario };

        if (sessionStorage.getItem('infoOrg')) {
            // Combinamos los datos del formulario con los datos de la sesión
            let data = JSON.parse(sessionStorage.getItem('infoOrg'));
            newForm = { ...data, ...formulario };
        }

        newForm[e.target.name] = e.target.value;
        // console.log(newForm);
        sessionStorage.setItem('infoOrg', JSON.stringify(newForm));
        setFormulario(newForm);
    };

    const sendData = async () => {
        let data = JSON.parse(sessionStorage.getItem('infoOrg'));
        // console.log(data, 'data');

        if (data.document_type === 'nit') {
            delete data.dui;
            delete data.other_document;
            delete data.name_other_document;
        } else if (data.document_type === 'dui') {
            delete data.nit;
            delete data.other_document;
            delete data.name_other_document;
        } else {
            delete data.nit;
            delete data.dui;
        }

        let session = getSession();
        let companyId = session.company.id

        let response = await postOrPutRequest(
            `company/update/${companyId}?_method=PUT`,
            'POST',
            data
        );

        if (response.type === 'success') {
            sessionStorage.removeItem('infoOrg');
            Swal.fire({
            	title: '¡Éxito!',
            	text: 'Información actualizada exitosamente',
            	icon: 'success',
            	confirmButtonText: 'Aceptar',
            }).then(() => {
                navigate('/IndicatorForm');
            });
            return;
        } else {
            Swal.fire({
            	title: response.message,
            	text: 'Verifique su información',
            	icon: 'warning',
            	confirmButtonText: 'Aceptar',
            });
            return;
        }
    };

    const allFunctions = async () => {
        setLoading(true);

        // await getBusinessSectors();

        if (sessionStorage.getItem('infoOrg')) {
            let data = JSON.parse(sessionStorage.getItem('infoOrg'));
            setFormulario(data);
        }

        // await getCities();

        // await getDistricts();

        // if (id) {
        //     await getData(id);
        // }

        setLoading(false);
    }

    useEffect(() => {
        allFunctions();
    }, []);

    return (
        <>
            <form onSubmit={validateDataForm}>
                <div className="mb-2">
                    <label className="mb-1 block font-medium text-xs text-slate-700 dark:text-white">
                        Nombres del representante
                    </label>
                    <div className="relative">
                        <input
                            type="text"
                            name="names"
                            placeholder=""
                            className="w-full text-xs md:text-sm rounded-md border border-stroke placeholder-stone-400 dark:border-stone-400 bg-transparent py-2 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa focus-visible:shadow-none dark:text-white" 
                            onChange={(e) => hanldeChange(e)}
                            value={formulario.names}
                        />
                        {/* <FormError errors={alert} name={"names"} /> */}
                    </div>
                </div>
                <div className="mb-2">
                    <label className="mb-1 block font-medium text-xs text-slate-700 dark:text-white">
                        Apellidos del representante
                    </label>
                    <div className="relative">
                        <input
                            type="text"
                            name="lastnames"
                            placeholder=""
                            className="w-full text-xs md:text-sm rounded-md border border-stroke placeholder-stone-400 dark:border-stone-400 bg-transparent py-2 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa focus-visible:shadow-none dark:text-white" 
                            onChange={(e) => hanldeChange(e)}
                            value={formulario.lastnames}
                        />
                        {/* <FormError errors={alert} name={"lastnames"} /> */}
                    </div>
                </div>
                <div className="mb-2">
                    <label className="mb-1 block font-medium text-xs text-slate-700 dark:text-white">
                        Cuéntanos sobre tu organización
                    </label>
                    <div className="relative">
                        <textarea
                            placeholder=""
                            name="about_us"
                            className="w-full text-xs md:text-sm rounded-md border border-stroke placeholder-stone-400 dark:border-stone-400 bg-transparent py-2 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa focus-visible:shadow-none dark:text-white resize-none h-24"
                            onChange={(e) => hanldeChange(e)}
                            value={formulario.about_us}
                        />
                        {/* <FormError errors={alert} name={"about_us"} /> */}

                    </div>
                </div>
                <div className="flex justify-end">
                    <button
                        type="button"
                        className="bg-turquesa w-full text-white text-xs md:text-sm rounded-md py-2 px-4"
                        onClick={ sendData }
                    >
                        Continuar
                    </button>
                </div>
            </form>

        </>
    )
}

export default InfoOrg3;